export const iceConfiguration = {
    iceServers: [
        {
            urls: 'turn:www.dihs-online-therapie.de:3478',
            username: 'test',
            credential: 'test123'
        }
    ]
}